import React from 'react';
import { connect } from 'react-redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { Switch, withRouter } from "react-router";
import PrivateRoute from '../../privateRoute';
import IndustryAnalysisSearchForm from "./industryAnalysisSearchForm.jsx";
import IndustryAnalysisResult from './industryAnalysisResult.jsx';

class IndustryAnalysisComponent extends React.Component {
    render() {
        const agentLanguage = this.props.user.authentication.profile.agentLanguage;

        return (
            <div className='content-root content-root-wide'>
                <Switch>
                    <PrivateRoute exact path={`${this.props.match.url}`} component={IndustryAnalysisSearchForm} componentProps={this.props} />
                    <PrivateRoute exact path={`${this.props.match.url}/results/:year?/:pointer?/:nace?`} component={IndustryAnalysisResult} componentProps={this.props} />
                </Switch>
                {!this.props.match || this.props.match.url !== this.props.location.pathname && <div className="disclaimer-wrapper">
                    <div className="disclaimer-gray">
                        <Translate id={`Report.Disclaimer${(agentLanguage === 'sk-SK' ? "Sk" : "Cz")}`} options={{ renderInnerHtml: true }} />
                    </div>
                </div>}
            </div>
        )
    }
}

export default withRouter(withLocalize(connect(
    state => ({ user: state.userContext })
)(IndustryAnalysisComponent)));